import * as React from 'react';

/**
 * Returns a unique symbol representing the component during its whole lifecycle. The symbol
 * can be used to lookup the position in the window.stackables: [symbol]. This is useful
 * when building portal-like components (modals, popups) to prevent unintended onClose
 * functions being called when clicking outside the bounds of the component in a stacked usecase.
 *
 * @param isOpen - whether the consumer (a stackable portal component) is open or not
 */
const useStackablePortal = (isOpen: boolean) => {
  const key = React.useRef(Symbol());
  React.useEffect(() => {
    if (isOpen) {
      window.stackables.push(key.current);
    }
    return () => {
      if (isOpen) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const toRemove = window.stackables.indexOf(key.current);
        window.stackables.splice(toRemove, 1);
      }
    };
  }, [isOpen]);
  return key.current;
};

const isTopOfStack = (key: symbol) => window.stackables[window.stackables.length - 1] === key;

export { isTopOfStack };

export default useStackablePortal;
